(function () {
  'use strict';

  var STORAGE_PREFIX = 'bsign_attribution_';
  var COOKIE_DAYS = 90;
  var COOKIE_MAX_AGE = COOKIE_DAYS * 24 * 60 * 60;
  var ATTRIBUTION_KEYS = [
    'gclid',
    'gbraid',
    'wbraid',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'landing_page',
    'first_page_url',
    'timestamp',
    'gclid_first_seen_at'
  ];
  var CAMPAIGN_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var CLICK_ID_KEYS = ['gclid', 'gbraid', 'wbraid'];
  var observerScheduled = false;

  function safeLocalStorageGet(key) {
    try {
      return window.localStorage ? window.localStorage.getItem(key) || '' : '';
    } catch (error) {
      return '';
    }
  }

  function safeLocalStorageSet(key, value) {
    try {
      if (!window.localStorage) return;

      if (value) {
        window.localStorage.setItem(key, value);
      } else {
        window.localStorage.removeItem(key);
      }
    } catch (error) {
      // Cookies remain as the fallback when storage is blocked.
    }
  }

  function readCookie(key) {
    var cookieName = encodeURIComponent(key) + '=';
    var cookies = document.cookie ? document.cookie.split(';') : [];

    for (var index = 0; index < cookies.length; index += 1) {
      var cookie = cookies[index].trim();

      if (cookie.indexOf(cookieName) === 0) {
        try {
          return decodeURIComponent(cookie.slice(cookieName.length));
        } catch (error) {
          return cookie.slice(cookieName.length);
        }
      }
    }

    return '';
  }

  function writeCookie(key, value) {
    var cookie = encodeURIComponent(key) + '=' + encodeURIComponent(value || '') + '; path=/; max-age=' + COOKIE_MAX_AGE + '; SameSite=Lax';

    if (window.location.protocol === 'https:') {
      cookie += '; Secure';
    }

    document.cookie = cookie;
  }

  function getStoredValue(key) {
    return (
      safeLocalStorageGet(STORAGE_PREFIX + key) ||
      safeLocalStorageGet(key) ||
      readCookie(STORAGE_PREFIX + key) ||
      readCookie(key)
    );
  }

  function storeValue(key, value) {
    var normalizedValue = value ? String(value) : '';

    safeLocalStorageSet(STORAGE_PREFIX + key, normalizedValue);
    safeLocalStorageSet(key, normalizedValue);
    writeCookie(STORAGE_PREFIX + key, normalizedValue);
    writeCookie(key, normalizedValue);
  }

  function sanitizeValue(value, maxLength) {
    if (typeof value !== 'string') return '';

    return value.trim().replace(/[\u0000-\u001F\u007F]/g, '').slice(0, maxLength || 1000);
  }

  function validClickId(value) {
    var normalizedValue = sanitizeValue(value, 256);

    return /^[A-Za-z0-9._~-]{3,256}$/.test(normalizedValue) ? normalizedValue : '';
  }

  function currentUrl() {
    return window.location.href;
  }

  function captureAttribution() {
    var now = new Date().toISOString();
    var url;

    try {
      url = new URL(currentUrl());
    } catch (error) {
      return getData();
    }

    if (!getStoredValue('first_page_url')) {
      storeValue('first_page_url', sanitizeValue(url.href, 2000));
    }

    if (!getStoredValue('landing_page')) {
      storeValue('landing_page', sanitizeValue(url.origin + url.pathname, 2000));
    }

    if (!getStoredValue('timestamp')) {
      storeValue('timestamp', now);
    }

    var incomingGclid = validClickId(url.searchParams.get('gclid') || '');
    var existingGclid = getStoredValue('gclid');

    if (incomingGclid && incomingGclid !== existingGclid) {
      storeValue('gclid', incomingGclid);
      storeValue('gclid_first_seen_at', now);

      CLICK_ID_KEYS.slice(1).forEach(function (key) {
        storeValue(key, validClickId(url.searchParams.get(key) || ''));
      });

      CAMPAIGN_KEYS.forEach(function (key) {
        storeValue(key, sanitizeValue(url.searchParams.get(key) || '', 500));
      });
    } else {
      CLICK_ID_KEYS.slice(1).forEach(function (key) {
        var clickId = validClickId(url.searchParams.get(key) || '');

        if (clickId) storeValue(key, clickId);
      });

      CAMPAIGN_KEYS.forEach(function (key) {
        var campaignValue = sanitizeValue(url.searchParams.get(key) || '', 500);

        if (campaignValue) storeValue(key, campaignValue);
      });
    }

    if (getStoredValue('gclid') && !getStoredValue('gclid_first_seen_at')) {
      storeValue('gclid_first_seen_at', now);
    }

    return getData();
  }

  function getData() {
    var data = {};

    ATTRIBUTION_KEYS.forEach(function (key) {
      data[key] = getStoredValue(key);
    });

    return data;
  }

  function isExcludedForm(form) {
    var action = (form.getAttribute('action') || '').toLowerCase();
    var role = (form.getAttribute('role') || '').toLowerCase();
    var className = String(form.className || '').toLowerCase();

    return (
      role === 'search' ||
      /(^|\/)(search|cart|checkout|account)(\/|$|\?)/.test(action) ||
      action.indexOf('/localization') !== -1 ||
      className.indexOf('search') !== -1 ||
      className.indexOf('filter-form') !== -1 ||
      className.indexOf('product-single__form') !== -1 ||
      form.hasAttribute('data-disclosure-form') ||
      form.querySelector('[name="q"]') !== null ||
      form.querySelector('[name="form_type"][value="product"]') !== null ||
      form.querySelector('[name="form_type"][value="localization"]') !== null
    );
  }

  function isLeadForm(form) {
    if (!form || form.tagName !== 'FORM' || isExcludedForm(form)) return false;
    if (form.classList.contains('custom-order-modal__form') || getSourceMarker(form)) return true;

    var hasContactEmail =
      form.querySelector('[name="contact[email]"], input[type="email"], input[name*="email" i]') !== null;
    var hasLeadContent =
      form.querySelector(
        '[name="contact[body]"], [name="contact[message]"], [name="contact[tags]"][value="catalog"], textarea[name*="message" i], textarea[name*="details" i], [name="contact[phone]"], input[type="tel"]'
      ) !== null;

    return hasContactEmail && hasLeadContent;
  }

  function fieldName(form, key) {
    var usesShopifyContactFields =
      form.querySelector('[name^="contact["]') !== null ||
      form.querySelector('[name="form_type"][value="contact"]') !== null ||
      form.classList.contains('custom-order-modal__form');

    return usesShopifyContactFields ? 'contact[' + key + ']' : key;
  }

  function findTrackingInput(form, key) {
    return form.querySelector('[data-bsign-tracking-key="' + key + '"]');
  }

  function setHiddenField(form, key, value) {
    var input = findTrackingInput(form, key);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.setAttribute('data-bsign-tracking-key', key);
      form.appendChild(input);
    }

    input.name = fieldName(form, key);
    input.value = value || '';

    if (input.hasAttribute('form')) {
      input.setAttribute('form', form.id);
    }
  }

  function getSourceMarker(form) {
    var sourceMarker = form.querySelector('[data-bsign-lead-form]');

    if (!sourceMarker && form.id) {
      sourceMarker = document.querySelector('[data-bsign-lead-form][form="' + form.id.replace(/"/g, '\\"') + '"]');
    }

    return sourceMarker;
  }

  function explicitFormSource(form) {
    var sourceMarker = getSourceMarker(form);

    return sourceMarker ? sanitizeValue(sourceMarker.value || sourceMarker.getAttribute('data-form-source') || '', 120) : '';
  }

  function slug(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .slice(0, 80);
  }

  function inferFormSource(form) {
    var explicitSource = explicitFormSource(form);
    var path = window.location.pathname.toLowerCase();
    var isCustomOrder = form.classList.contains('custom-order-modal__form') || form.querySelector('[data-custom-order-fields]') !== null;

    if (explicitSource) return explicitSource;
    if (isCustomOrder && path.indexOf('/products/') !== -1) return 'product_custom_order';
    if (isCustomOrder && path.indexOf('contact') !== -1) return 'contact_us_custom_order';
    if (isCustomOrder && path.indexOf('about') !== -1) return 'about_contact_us';
    if (isCustomOrder && (path.indexOf('help') !== -1 || path.indexOf('custom-order') !== -1)) return 'help_center_custom_order';
    if (isCustomOrder) return 'custom_order_request';
    if (path.indexOf('about') !== -1) return 'about_contact_us';
    if (path.indexOf('contact') !== -1) return 'contact_us';

    return 'lead_' + (slug(form.id) || slug(path) || 'contact_form');
  }

  function productContext(form) {
    var sourceMarker = getSourceMarker(form);
    var canonical = document.querySelector('link[rel="canonical"]');
    var titleMeta = document.querySelector('meta[property="og:title"]');
    var productUrl = sourceMarker ? sourceMarker.getAttribute('data-product-url') || '' : '';
    var productTitle = sourceMarker ? sourceMarker.getAttribute('data-product-title') || '' : '';
    var sku = sourceMarker ? sourceMarker.getAttribute('data-product-sku') || '' : '';

    if (!productUrl && window.location.pathname.indexOf('/products/') !== -1) {
      productUrl = canonical ? canonical.href : window.location.origin + window.location.pathname;
    }

    if (!productTitle && productUrl) {
      productTitle = titleMeta ? titleMeta.getAttribute('content') || '' : document.title;
    }

    return {
      product_url: sanitizeValue(productUrl, 2000),
      product_title: sanitizeValue(productTitle, 500),
      sku: sanitizeValue(sku, 200)
    };
  }

  function populateLeadForm(form) {
    if (!isLeadForm(form)) return;

    var data = getData();
    var product = productContext(form);
    var fields = {
      gclid: data.gclid,
      gbraid: data.gbraid,
      wbraid: data.wbraid,
      page_url: currentUrl(),
      form_source: inferFormSource(form),
      landing_page: data.landing_page,
      first_page_url: data.first_page_url,
      utm_source: data.utm_source,
      utm_medium: data.utm_medium,
      utm_campaign: data.utm_campaign,
      utm_content: data.utm_content,
      utm_term: data.utm_term,
      gclid_first_seen_at: data.gclid_first_seen_at,
      first_visit_at: data.timestamp,
      product_url: product.product_url,
      product_title: product.product_title,
      sku: product.sku
    };

    Object.keys(fields).forEach(function (key) {
      setHiddenField(form, key, fields[key]);
    });

    form.setAttribute('data-bsign-attribution-ready', 'true');
  }

  function initializeForms(root) {
    var forms = [];

    if (root && root.tagName === 'FORM') forms.push(root);
    if (root && root.querySelectorAll) {
      forms = forms.concat(Array.prototype.slice.call(root.querySelectorAll('form')));
    }

    forms.forEach(function (form) {
      populateLeadForm(form);

      if (isCartForm(form)) populateCartForm(form);
    });
  }

  function cartAttributes(data) {
    function orderValue(value) {
      return sanitizeValue(value || '', 255);
    }

    return {
      GCLID: orderValue(data.gclid),
      GBRAID: orderValue(data.gbraid),
      WBRAID: orderValue(data.wbraid),
      'Landing page': orderValue(data.landing_page),
      'First page URL': orderValue(data.first_page_url),
      'First visit at': orderValue(data.timestamp),
      'GCLID first seen at': orderValue(data.gclid_first_seen_at),
      'UTM source': orderValue(data.utm_source),
      'UTM medium': orderValue(data.utm_medium),
      'UTM campaign': orderValue(data.utm_campaign),
      'UTM content': orderValue(data.utm_content),
      'UTM term': orderValue(data.utm_term)
    };
  }

  function isCartForm(form) {
    var action = (form.getAttribute('action') || '').split('?')[0].replace(/\/+$/, '');

    return action === '/cart' || form.id === 'CartPageForm' || form.id === 'CartDrawerForm';
  }

  function isProductForm(form) {
    return form.querySelector('[name="form_type"][value="product"]') !== null;
  }

  function populateCartForm(form) {
    var attributes = cartAttributes(getData());

    Object.keys(attributes).forEach(function (key) {
      if (!attributes[key]) return;

      var selector = 'input[data-bsign-cart-attribute="' + key.replace(/"/g, '\\"') + '"]';
      var input = form.querySelector(selector);

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.setAttribute('data-bsign-cart-attribute', key);
        form.appendChild(input);
      }

      input.name = 'attributes[' + key + ']';
      input.value = attributes[key];
    });
  }

  function syncCartAttributes(force) {
    var data = getData();

    if (!data.gclid && !data.gbraid && !data.wbraid) {
      return Promise.resolve(false);
    }

    var attributes = cartAttributes(data);
    var signature = JSON.stringify(attributes);

    try {
      if (!force && window.sessionStorage && window.sessionStorage.getItem('bsign_cart_attribution_signature') === signature) {
        return Promise.resolve(true);
      }
    } catch (error) {
      // Continue with the request if session storage is blocked.
    }

    if (!window.fetch) return Promise.resolve(false);

    return window
      .fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ attributes: attributes })
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to save cart attribution');

        try {
          if (window.sessionStorage) {
            window.sessionStorage.setItem('bsign_cart_attribution_signature', signature);
          }
        } catch (error) {
          // The cart update already succeeded.
        }

        return true;
      })
      .catch(function () {
        return false;
      });
  }

  function handleSubmit(event) {
    var form = event.target;

    if (!form || form.tagName !== 'FORM') return;

    if (isLeadForm(form)) {
      populateLeadForm(form);
    }

    if (isCartForm(form)) {
      populateCartForm(form);
      syncCartAttributes(true);
    }

    if (isProductForm(form)) {
      syncCartAttributes(true);
    }
  }

  function handleCheckoutIntent(event) {
    var target = event.target && event.target.closest
      ? event.target.closest('[name="checkout"], .shopify-payment-button, .additional-checkout-buttons')
      : null;

    if (target) syncCartAttributes(true);
  }

  function handleVariantChange(event) {
    var variant = event.detail && event.detail.variant;

    if (!variant) return;

    var markers = document.querySelectorAll('[data-bsign-lead-form][data-product-url]');

    Array.prototype.forEach.call(markers, function (marker) {
      if (marker.getAttribute('data-product-url')) {
        marker.setAttribute('data-product-sku', sanitizeValue(variant.sku || '', 200));
      }
    });

    initializeForms(document);
  }

  function observeDynamicForms() {
    if (!window.MutationObserver || !document.documentElement) return;

    var observer = new MutationObserver(function (mutations) {
      if (observerScheduled) return;

      var hasAddedNodes = mutations.some(function (mutation) {
        return mutation.addedNodes && mutation.addedNodes.length;
      });

      if (!hasAddedNodes) return;
      observerScheduled = true;

      window.requestAnimationFrame(function () {
        observerScheduled = false;
        initializeForms(document);
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function init() {
    captureAttribution();
    initializeForms(document);
    observeDynamicForms();
    syncCartAttributes(false);

    document.addEventListener('submit', handleSubmit, true);
    document.addEventListener('pointerdown', handleCheckoutIntent, true);
    document.addEventListener('click', handleCheckoutIntent, true);
    document.addEventListener('variant:change', handleVariantChange);
  }

  window.BsignTracking = {
    capture: captureAttribution,
    getData: getData,
    refreshForms: function () {
      initializeForms(document);
    },
    syncCart: function () {
      return syncCartAttributes(true);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
